var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRing2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "133px",
    height: "146px",
    viewBox: "0 0 133 146",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-293.000000, -338.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANIMATE_intro?scale&delay=2.4-Copy-3",
    transform: "translate(294.000000, 339.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cta",
    transform: "translate(-0.000050, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/hexogon-cta",
    transform: "translate(0.000000, 0.000250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.4365,143.258 C60.9825,143.258 56.691,142.1395 53.027,140.0235 L12.4085,116.573 C4.9865,112.287 0,103.6495 0,95.0805 L0,48.1775 C0,39.608 4.9865,30.971 12.4075,26.6855 L53.028,3.2335 C56.693,1.118 60.9835,1.08420217e-19 65.4365,1.08420217e-19 C69.89,1.08420217e-19 74.1805,1.1175 77.844,3.2325 L118.4645,26.685 C125.887,30.9705 130.873,39.608 130.873,48.1775 L130.873,95.0805 C130.873,103.651 125.886,112.2885 118.4635,116.5735 L77.845,140.024 C74.1815,142.1395 69.8905,143.258 65.4365,143.258 Z",
    id: "ring-2"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing2);
export default __webpack_public_path__ + "static/media/ring-2.e6ce0a6fa3ff32051c4a494548ad8156.svg";
export { ForwardRef as ReactComponent };